import CryptoJS from 'crypto-js/crypto-js'

//默认自定义的约定密钥(与后端密钥保持一致)
const KEY = CryptoJS.enc.Utf8.parse("ugxxmyfrbh9cgg2s");// 密钥16位长度字符
const IV = CryptoJS.enc.Utf8.parse("a4cehrwwtew8pwty"); //  密钥偏移量

/**
* AES对称加密 （CBC模式，需要偏移量）
* @param {Object} params 明文参数
*/
export const encrypt = (str, keyStr, ivStr) =>{
    let key = KEY
    let iv = IV
	
  	//如果在加密解密的时候没有传入KEY和IV,就会使用默认自定义的
    if (keyStr && ivStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }
	//明文
    let srcs = CryptoJS.enc.Utf8.parse(str);
    //加密
    var encrypt = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC, //AES加密模式
        padding: CryptoJS.pad.Pkcs7 //填充方式
    });
    return CryptoJS.enc.Base64.stringify(encrypt.ciphertext); //返回base64格式密文
}

// 最后的加密
export const encryptLast = (data) => {
    let num = suijione(true, false, false, 16);
    let encryptData = {
        abc: new Date().getTime()+encrypt(num),
        qwe: encrypt(JSON.stringify(data), num, 'a4cehrwwtew8pwty')
    };
	return encryptData;
}

/**
* AES对称解密
* @param {Object} params 加密参数
*/
export const decrypt = (str, keyStr, ivStr) => {
    let key = KEY
    let iv = IV
	
	//如果在加密解密的时候没有传入KEY和IV,就会使用默认自定义的
    if (keyStr && ivStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }
    
	//base64格式密文转换
    let base64 = CryptoJS.enc.Base64.parse(str);
    let src = CryptoJS.enc.Base64.stringify(base64);
	//解密
    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC, //AES加密模式
        padding: CryptoJS.pad.Pkcs7 //填充方式
    });
	return CryptoJS.enc.Utf8.stringify(decrypt).toString(); //返回明文
}

// 最后的解密
export const decryptLast = (par) => {
    let qweKey = decrypt(par.abc.substring(13)),
        decryptData = decrypt(par.qwe, qweKey, 'a4cehrwwtew8pwty');
    if (isJSON(decryptData)) {
        decryptData = JSON.parse(decryptData);
    }
	return decryptData;
}

// 
export const decryptL = (par, key, iv) => {
    let decryptData = decrypt(par, key, iv);
	return decryptData;
}

export const suijione = (num,maxA,minlA,fqy) =>{
    let arr=[]
    let arr1=[]
    let arr2=[]
    if(num){
        for(let m=0;m<=9;m++){
            arr.push(m)
        }
    }
    if(maxA){
        for(let m=65;m<=90;m++){
            arr1.push(m)
        }
    }
    if(minlA){
        for(let m=97;m<=122;m++){
            arr2.push(m)
        }
    }
    if(!fqy){
        console.log('生成位数必传')
    }
    let mergeArr = arr.concat(arr1);
    let mergeArr1 = mergeArr.concat(arr2);
    let _length=mergeArr1.length
   let text=''
    for(let m=0;m<fqy;m++){
        let text1=''
        let random= getRandom(0,_length)
        if((mergeArr1[random])<=9){
            text1=mergeArr1[random]
        }else if((mergeArr1[random])>9){
            text1=String.fromCharCode(mergeArr1[random])
        }
        text+=text1
    }
    return text
}


export const getRandom = (a,b) =>{
    var max = a;
    var min = b;
    if(a<b){
        max = b;
        min = a;
    }
    return parseInt(Math.random()*(max-min))+min;
};

export const isJSON = (str) => {
    if (typeof str == 'string') {
        try {
        var obj=JSON.parse(str);
        if(typeof obj == 'object' && obj ){
            return true;
        }else{
            return false;
        }

        } catch(e) {
        return false;
        }
    }
    return false;
}

export default {
  encrypt,
  decrypt,
  decryptLast,
  decryptL,
  encryptLast,
  isJSON,
  suijione,
  getRandom
}